<div mat-dialog-title fxLayout fxLayoutAlign="space-between center">
    <div fxLayout fxLayoutAlign="start center">
        @if (info()?.revisions.length > 1) {
            <button
                mat-mini-fab
                color="accent"
                class="m-y-xs m-r"
                [matMenuTriggerFor]="revisions"
                [attr.aria-label]="'a11y.document.revisions' | translate">
                <mat-icon class="material-symbols-outlined" aria-hidden="true">tab_group</mat-icon>
            </button>
            <mat-menu #revisions="matMenu">
                @for (revision of info().revisions; track $index) {
                    <button
                        mat-menu-item
                        (click)="selectDocument(revision.entityInstanceId)"
                        [disabled]="revision.entityInstanceId === info().entityInstanceId">
                        <span>{{ revision.moduleDocumentNumber }} ({{ revision.revision }})</span>
                    </button>
                }
            </mat-menu>
        }
        <h5 class="cipo--text--ellipsed m-r">
            @if (info()) {
                @let parent = info().originalModuleDocumentNumber;
                @let revisionMessage = info()?.existingDraftMessage;
                {{ currentModule().name }} {{ info()?.moduleDocumentNumber }}
                {{ (info().isDraftState ? "dm.details.createdBy" : "") | translate: info() }}
                @if (parent) {
                    ({{ "dm.details.revisionOf" | translate: { parent } }})
                } @else if (revisionMessage) {
                    <span class="cipo-text--bold-md cipo-text--black-900 p-l-sm">
                        <span class="cipo-bg--warning-lite cipo--border-radius--sm p-a-xs">
                            {{ revisionMessage }}
                        </span>
                    </span>
                }
            } @else if (currentDocument().params.entityInstanceId === 0) {
                {{ "dm.details.addTitle" | translate: { module: currentModule().name } }}
            } @else {
                {{ currentModule().name }}
            }
        </h5>
        @if (info()?.approvalId) {
            <cipo-state name="defaultStatus.AwaitingApproval" [bgColor]="APPROVAL_COLOR" />
        }
    </div>
    <div fxLayout fxLayoutAlign="center center" fxLayoutGap="12px">
        @if (autosaveInProgress()) {
            <p>{{ "dm.messages.autosaveInProgress" | translate }}</p>
        }
        @if (currentDocument().params.screenId) {
            <p class="cipo-text--medium-lg">{{ startScreens()[currentDocument().params.screenId] }}</p>
        }
        <button mat-icon-button (click)="toggleAiAssistant()" [attr.aria-label]="'a11y.header.cipoAI' | translate">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">live_help</mat-icon>
        </button>
        <button
            mat-icon-button
            (click)="fullscreen.toggleFullscreen()"
            [attr.aria-label]="
                (fullscreen.isFullscreen() ? 'a11y.dialog.fullscreenExit' : 'a11y.dialog.fullscreenEnter') | translate
            ">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
                {{ fullscreen.isFullscreen() ? "close_fullscreen" : "fullscreen" }}
            </mat-icon>
        </button>
        <button
            mat-icon-button
            [matDialogClose]="currentDocument().info"
            [aria-label]="'a11y.dialog.close' | translate">
            <mat-icon aria-hidden="true">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="p-a-0">
    <div fxLayout class="cipo--height--full cipo--overflow--hidden">
        <!-- Sidebar documents -->
        @if (data.showSidebar && currentDocument().params.entityInstanceId) {
            <div fxFlex="none" fxHide.lt-md class="cipo--height--full">
                <cipo-document-sidebar
                    [allDisable]="(editing() && !isDraft()) || transitionStarted()"
                    [selectedEntityInstanceId]="selectedEntityInstanceId()"
                    (selectDocument)="selectDocument($event.entity_instance_id, $event.screen_id)" />
            </div>
        }

        <div fxFlex="grow" class="cipo--overflow--auto cipo--height--full" [class.p-b-sm]="!selectedTabIndex()">
            @if (showTabs()) {
                <mat-tab-group
                    mat-stretch-tabs="false"
                    color="accent"
                    [(selectedIndex)]="selectedTabIndex"
                    class="cipo--height--full">
                    <mat-tab label="Details">
                        <ng-container *ngTemplateOutlet="detailstTab"></ng-container>
                    </mat-tab>
                    <mat-tab label="Assignments">
                        <ng-template matTabContent>
                            <cipo-assignments
                                [entityinstanceid]="currentDocument().params.entityInstanceId"
                                [moduleid]="currentDocument().params.moduleId"
                                [hasupdate]="info().canUpdate"
                                (assignmentchanged)="assignmentChanged()" />
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            } @else {
                <ng-container *ngTemplateOutlet="detailstTab"></ng-container>
            }
        </div>
    </div>
</mat-dialog-content>
@if (selectedTabIndex() === 0) {
    <mat-dialog-actions>
        <div class="cipo--width--full">
            @if (actionsData()) {
                <cipo-document-actions
                    [actions]="moreActions()"
                    [data]="actionsData()"
                    [transitions]="filteredTransitions()"
                    (cancelRequested)="discardChanges()"
                    (submitRequested)="handleSubmit()"
                    (docNumChanged)="docNumChanged($event)"
                    (assignmentChanged)="onAssignmentChanged($event)"
                    (actionClicked)="handleMoreActions($event)"
                    (transitionClicked)="handleTransitionClick($event)" />
            }
        </div>
    </mat-dialog-actions>
}
<input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" [accept]="fileAccept()" />

<ng-template #detailstTab>
    <div class="p-x cipo-bg--primary-100 m-b p-b">
        <cipo-document-header [data]="headerData()" />
    </div>
    <cipo-horizontal-splitter [leftPaneOptions]="leftPaneOptions()" [resizeStepper]="5" (onResize)="onResize($event)">
        <div class="p-x" leftContent>
            @if (transitionStarted()) {
                <div fxLayoutAlign="end center">
                    @let title = "actions." + (leftPaneCollapsed() ? "expand" : "collapse") | translate;
                    <button
                        mat-icon-button
                        color="accent"
                        (click)="onResize(leftPaneCollapsed() ? 50 : 0.05)"
                        [matTooltip]="title"
                        [attr.aria-label]="title">
                        <mat-icon class="material-symbols-outlined" aria-hidden="true">
                            {{ leftPaneCollapsed() ? "right_panel_close" : "right_panel_open" }}
                        </mat-icon>
                    </button>
                </div>
            }
            @if (!leftPaneCollapsed()) {
                @if (info()?.approvalId) {
                    <div class="m-b p-b cipo--border-bottom--lite">
                        <cipo-awaiting-approval [entityInstanceInfo]="info()" (reload)="handleDocumentReviewed()" />
                    </div>
                }
                @if (gridFields()) {
                    @defer (on idle) {
                        <cipo-dynamic-form
                            #dynamicForm
                            [form]="form"
                            [class.p-b]="isDraft()"
                            [fields]="gridFields().fields"
                            [contractId]="currentDocument().params.contractId"
                            [readonly]="!editing()"
                            (formValuesPrepared)="onUpdatesSubmit($event)" />
                    } @placeholder {
                        <ngx-skeleton-loader
                            [theme]="{ width: '30%', height: '50px', margin: '10px' }"
                            count="3"></ngx-skeleton-loader>
                    }
                } @else {
                    <ngx-skeleton-loader
                        [theme]="{ width: '30%', height: '50px', margin: '10px' }"
                        count="3"></ngx-skeleton-loader>
                }
            }
        </div>
        <!-- Transition form -->
        @if (transitionStarted()) {
            <div class="p-a" rightContent>
                <cipo-details-transition
                    #transitionFormComponent
                    [form]="transitionForm"
                    [compactMode]="compactTransitionForm()"
                    [entityInstanceId]="selectedEntityInstanceId()"
                    (transitionFormPrepared)="executeTransition($event)" />
            </div>
        }
    </cipo-horizontal-splitter>

    @if (info() && !isDraft()) {
        <div class="cipo--border-top--lite m-a p-t">
            <cipo-document-details-tabs [entityInstanceId]="selectedEntityInstanceId()" />
        </div>
    }
</ng-template>
